import { useEffect, useMemo, useRef, useState } from 'react';
import styles from './teams.module.css'
import TeamsOverlay from '../../overlays/teams/teams-overlay';

import leaderImg from '../../assets/teams/Leader.svg';

import { useInView } from '../../hooks/in-view';
import teams from '../../data/teams';
import CheckMoreButton from '../../components/check-more/check-more';

function TeamsSlide() {
    

    const {ref, inView} = useInView({
        threshold: 0.5
    }, {
        once: true,
        resetOnExit: false
    })

    const lastMember = useRef(null);
    
    const [hoverable, setHoverable] = useState(false);

    useEffect(() => {
        console.log(lastMember.current)
        lastMember.current.ontransitionend = function() {
            setHoverable(true);
        }
    }, []);

    function getRandomTeam() {
        const tk = Object.keys(teams);
        return tk[Math.ceil(Math.random() * tk.length) - 1];
    }

    const [isOverlayOpen, _setOverlayOpen] = useState(false);

    function setOverlayOpen(b) {
        if (b) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        _setOverlayOpen(b);
    }

    const shownTeam = useMemo(() => getRandomTeam(), []);

    return (
        <>
            <div className={styles.wrapper} id="teams">
                <div className={styles.container}>
                    <div className={styles.content}>
                        <div className={styles['content-title']}>Teams</div>
                        <div ref={ref} className={styles['team-cards']}>
                            <a rel="noreferrer" target="_blank" href={teams[shownTeam].leader.url} className={[styles['team-image-container'], inView ? styles['team-image-container-visible-0'] : '', hoverable ? styles.hoverable : ''].join(" ")}>
                                <img src={teams[shownTeam].leader.img} className={styles['team-image-image']} alt={teams[shownTeam].leader.name} />
                                <div style={{fontFamily: (teams[shownTeam].altFont || teams[shownTeam].leader.altFont) ? 'impact' : 'kuramubon'}} className={styles['team-image-text']}>{teams[shownTeam].leader.name}</div>
                                <img className={`${styles['team-leader-image']} ${inView ? styles['team-leader-image-visible'] : ''}`} src={leaderImg} alt="leader" width="50%" />
                            </a>
                            <a rel="noreferrer" target="_blank" href={teams[shownTeam].member[0].url} className={[styles['team-image-container'], inView ? styles['team-image-container-visible-1'] : '', hoverable ? styles.hoverable : ''].join(" ")}>
                                <img style={{fontFamily: (teams[shownTeam].altFont || teams[shownTeam].member[0].altFont) ? 'impact' : 'kuramubon'}} src={teams[shownTeam].member[0].img} className={styles['team-image-image']} alt={teams[shownTeam].member[0].name} />
                                <div className={styles['team-image-text']}>{teams[shownTeam].member[0].name}</div>
                            </a>
                            <a rel="noreferrer" target="_blank" href={teams[shownTeam].member[1].url} className={[styles['team-image-container'], inView ? styles['team-image-container-visible-2'] : '', hoverable ? styles.hoverable : '', teams[shownTeam].member[1].name === 'パンの耳' ? styles['team-image-container-pantsu'] : ''].join(" ")}>
                                <img style={{fontFamily: (teams[shownTeam].altFont || teams[shownTeam].member[1].altFont) ? 'impact' : 'kuramubon'}} src={teams[shownTeam].member[1].img} className={styles['team-image-image']} alt={teams[shownTeam].member[1].name} />
                                <div className={styles['team-image-text']}>{teams[shownTeam].member[1].name}</div>
                            </a>
                            <a ref={lastMember} rel="noreferrer" target="_blank" href={teams[shownTeam].member[2].url} className={[styles['team-image-container'], inView ? styles['team-image-container-visible-3'] : '', hoverable ? styles.hoverable : ''].join(" ")}>
                                <img style={{fontFamily: (teams[shownTeam].altFont || teams[shownTeam].member[2].altFont) ? 'impact' : 'kuramubon'}} src={teams[shownTeam].member[2].img} className={styles['team-image-image']} alt={teams[shownTeam].member[2].name} />
                                <div className={styles['team-image-text']}>{teams[shownTeam].member[2].name}</div>
                            </a>
                        </div>
                        <div className={`${styles['team-name']} ${inView ? styles['team-name-visible'] : ''}`}>
                            {shownTeam}
                        </div>
                    </div>
                </div>

                <div className={styles['more']}>
                    <CheckMoreButton onClick={() => setOverlayOpen(!isOverlayOpen)} />
                </div>
            </div>
            {isOverlayOpen && <TeamsOverlay close={() => setOverlayOpen(false)} />}
        </>
    )
}

export default TeamsSlide